import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  Card,
  LinearProgress,
  Chip,
  FormControlLabel,
  Radio,
  Checkbox,
  TextField,
} from "@mui/material";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Form, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import LoadingGif from "../components/LoadingGif";
import { useState, useEffect } from "react";
import { ArrowLeft, ArrowRight, X, ChevronDown, ChevronUp } from "lucide-react";
import { SERVICE_OPTIONS } from "./HotelAdd_RoomInfoAdd_1";
import { useHotel } from "../context/HotelContext";
import { useRoom } from "../context/RoomContext";


const HotelOrderManagement = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { hotelId } = useParams();
  const isMobile = useMediaQuery("(max-width:950px)");
  const [currentTab, setCurrentTab] = useState("DashBoard");
  const [todaysDate, setTodaysDate] = useState("");
  const [day, setDay] = useState(false);
  const [checkInModal, setCheckInModal] = useState(false);
  const [checkOutModal, setCheckOutModal] = useState(false);
  const [checkInModalTime, setCheckInModalTime] = useState(false);
  const [checkOutModalTime, setCheckOutModalTime] = useState(false);
  const [selectedVerifications, setSelectedVerifications] = useState([]);
  const [dropdownAddOpen, setDropdownAddOpen] = useState(false);
  const [dropdownRoomOpen, setDropdownRoomOpen] = useState(false);
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [checkInNotes, setCheckInNotes] = useState("");
  const [reviewModal, setReviewModal] = useState(false);
  const { listUserHotels, fetchDraft, loading, } = useHotel();
  const { fetchPublishedRooms, ListRoomBookings, getPetBasicInfo, updateBookingStep, fetchReviewDocument } = useRoom();
  const [existingHotel, setExistingHotel] = useState(null);
  const [pendingBookings, setPendingBookings] = useState(0);
  const [publishedRooms, setPublishedRooms] = useState([]);
  const [todayBookings, setTodayBookings] = useState([]);
  const [reviewBookings, setReviewBookings] = useState([]);
  const [todayCheckIn, setTodayCheckIn] = useState(0);
  const [todayCheckOut, setTodayCheckOut] = useState(0);
  const [pet, setPet] = useState([]);
  const [modalData, setModalData] = useState({});
  const [additionalServices, setAdditionalServices] = useState({});
  const [assignRooms, setAssignRooms] = useState([]);
  const [reviewResults, setReviewResults] = useState("");
  const [unConfirmReason, setUnConfirmReason] = useState("");
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const [bookingUnConfirmed, setBookingUnConfirmed] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const isPdf = (file) => {
    if (!file) return false;
    if (typeof file === "string") return file.toLowerCase().endsWith(".pdf");
    return file.type === "application/pdf" || file.name?.toLowerCase().endsWith(".pdf");
  };


  const [checkInTime, setCheckInTime] = useState(() => {
    const now = new Date();
    now.setHours(now.getHours() + 8);
    return now.toISOString().slice(0, 16);
  });
  const [checkOutTime, setCheckOutTime] = useState(() => {
    const now = new Date();
    now.setHours(now.getHours() + 8);
    return now.toISOString().slice(0, 16);
  });

  const [formData, setFormData] = useState({
    addOnQuantities: {},
  });

  useEffect(() => {
    const checkExistingHotels = async () => {
      try {
        const hotels = await listUserHotels();
        if (hotels.length > 0) {
          setExistingHotel(hotels[0]);
          const published = await fetchPublishedRooms(hotelId);
          setPublishedRooms(published);
          const uniqueRoomIds = [...new Set(published.data.map((room) => room.roomId))];
          const allBookings = [];

          for (const roomId of uniqueRoomIds) {
            const bookings = await ListRoomBookings(roomId);
            allBookings.push(...bookings);
          }

          const today = new Date().toISOString().split('T')[0];

          let checkInCount = 0;
          let checkOutCount = 0;
          let reviewBookings = [];

          const todayFilteredBookings = allBookings.filter((booking) => {
            if (booking.checkIn?.isCheckedIn && booking.checkOut?.isCheckOut) {
              return false;
            }

            if (booking.checkIn.isCheckedIn === false && !booking.review) {
              reviewBookings.push(booking);
            }

            const checkInDate = booking.checkIn?.scheduledCheckIn
              ? new Date(booking.checkIn.scheduledCheckIn).toISOString().split('T')[0]
              : null;

            const checkOutDate = booking.checkOut?.scheduledCheckOut
              ? new Date(booking.checkOut.scheduledCheckOut).toISOString().split('T')[0]
              : null;

            if (checkInDate === today) {
              checkInCount++;
              booking.event = "checkIn";
              booking.scheduledTime = new Date(booking.checkIn.scheduledCheckIn).toISOString().split('T')[0];
            }
            if (checkOutDate === today) {
              if (booking.checkIn.isCheckedIn === false) {
                return false;
              }
              checkOutCount++;
              booking.event = "checkOut";
              booking.scheduledTime = new Date(booking.checkOut.scheduledCheckOut).toISOString().split('T')[0];
            }

            return checkInDate === today || checkOutDate === today;
          });

          setTodayBookings(todayFilteredBookings);
          setTodayCheckIn(checkInCount);
          setTodayCheckOut(checkOutCount);
          setReviewBookings(reviewBookings);
          console.log("Review Bookings:", reviewBookings);
          setPendingBookings(reviewBookings.length);
        }
      } catch (error) {
        console.error("Failed to fetch user hotels:", error);
      }
    };

    checkExistingHotels();
  }, [listUserHotels]);

  const calculateAge = (birthDate) => {
    const birth = new Date(birthDate);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    const dayDiff = today.getDate() - birth.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  };

  const displayTime = (isoString) => {
    return new Date(isoString).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });
  };


  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setTodaysDate(formattedDate);
  }, []);

  useEffect(() => {
    const today = new Date();
    const currentDay = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    setDay(currentDay);
  }, []);

  const handleAddOnQuantityChange = (serviceKey, value) => {
    setFormData((prev) => ({
      ...prev,
      addOnQuantities: {
        ...prev.addOnQuantities,
        [serviceKey]: value,
      },
    }));
  };

  const CalculateOccupancyRate = () => {
    const totalRooms = publishedRooms.total || 0;
    const occupiedRooms = publishedRooms.occupied || 0;
    return totalRooms > 0 ? ((occupiedRooms / totalRooms) * 100).toFixed(2) + "%" : "0%";
  };

  const handleOpenModal = async (bookingId, event) => {
    if (event === "checkIn") {
      setCheckInModal(true);
    } else if (event === "review") {
      setReviewModal(true);
    } else {
      setCheckOutModal(true);
    }

    let booking = null;
    if (event === "checkIn" || event === "checkOut") {
      booking = todayBookings.find((b) => b._id === bookingId);
    } else if (event === "review") {
      booking = reviewBookings.find((b) => b._id === bookingId)
    }
    setModalData(booking);
    const hotelData = await fetchDraft(hotelId);
    setAdditionalServices(hotelData.additionalServices || {});
    const petInfo = await getPetBasicInfo(booking.petId);
    setPet(petInfo);
    const roomsData = [];
    for (const room of publishedRooms.data) {
      if (room.roomId === booking.roomId && room.availability === "available") {
        roomsData.push(room);
      }
    }
    setAssignRooms(roomsData);
  }

  const todayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const tabs = [
    { key: "DashBoard", label: t("DashBoard") },
    { key: "BookingList", label: t("BookingList") },
    { key: "TenantsManagement", label: t("TenantsManagement") },
    { key: "RoomManagement", label: t("RoomManagement") },
  ];

  const reviewResultsLabel = [
    { id: 1, label: "ConfirmBooking", description: "CustomerWillBeNotified", },
    { id: 2, label: "UnableToConfirmBooking", description: "SelectReason", },
  ]

  const UnConfirmReviewReasonLabel = [
    { id: 1, label: "RequiredInfoDocs1", },
    { id: 2, label: "Care&Accomodation1", },
    { id: 3, label: "Care&Accomodation2", },
    { id: 4, label: "Care&Accomodation3", },
    { id: 5, label: "HotelOperations1", },
    { id: 6, label: "Other1", },
  ]

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#F5F5F5",
  };

  const contentStyle = {
    flex: "1 0 auto",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: isMobile ? "100px 20px 60px" : "120px 80px 80px",
    maxWidth: "1600px",
    width: "100%",
  };

  const OccupancyStatistics = (occupied, available) => {
    if (i18n.language === 'zh') {
      return `已入住 ${(occupied)}間 / 共${(available)}間`;
    }
    return `${(occupied)} of ${(available)} rooms occupied`;
  }

  const closeReviewModal = () => {
    setReviewModal(false);
    setReviewResults("");
  };

  const handleReviewBooking = async () => {
    setReviewModal(false);
    if (reviewResults === "ConfirmBooking") {
      const assignedRoom = assignRooms.find((room) => room.roomName === selectedRoomType);

      const payload = {
        assignedRooms: assignedRoom?._id || null,
      };
      try {
        await updateBookingStep(modalData._id, "confirmBooking", payload);
        setBookingConfirmed(true);
      } catch (error) {
        console.error("Failed to confirm check-in:", error);
      }
    } else {
      const payload = {
        unconfirmReason: unConfirmReason,
      };
      try {
        await updateBookingStep(modalData._id, "unconfirmBooking", payload);
        setBookingUnConfirmed(true);
      } catch (error) {
        console.error("Failed to confirm check-in:", error);
      }
    }
  };

  const openReviewDocument = async (bookingId) => {
    const response = await fetchReviewDocument(bookingId);
    if (response.success) {
      setPreviewFile({
        file: { name: "Document", type: response.mimeType },
        url: response.url,
      });
    }
  };

  const openCheckInTimeModal = () => {
    setCheckInModalTime(true);
    setCheckInModal(false);
  };

  const openCheckOutTimeModal = () => {
    setCheckOutModalTime(true);
    setCheckOutModal(false);
  };

  const confirmButtonDisabled1 =
    (checkInModal && (!selectedRoomType || selectedVerifications.length < 4)) || (checkOutModal && (!paymentConfirmed || selectedVerifications.length < 4));

  const confirmButtonDisabled2 =
    (reviewResults === "ConfirmBooking" && selectedRoomType) || (reviewResults === "UnableToConfirmBooking" && unConfirmReason);

  const buildAddOnServicesPayload = () => {
    const services = {};
    const quantities = {};
    const servicePrices = {};

    SERVICE_OPTIONS.forEach((service) => {
      if (additionalServices.selectedServices?.[service.key]) {
        services[service.key] = true;
        quantities[service.key] = Number(formData.addOnQuantities[service.key]) || 0;
        servicePrices[service.key] = additionalServices.servicePrices[service.key];
      }
    });

    return { services, quantities, servicePrices };
  };

  const handleConfirmCheckIn = async () => {
    const assignedRoom = assignRooms.find((room) => room.roomName === selectedRoomType);

    const payload = {
      isCheckedIn: true,
      actualCheckInTime: new Date(checkInTime).toISOString(),
      preCheckInItems: {
        verifiedPet: selectedVerifications.includes("pet"),
        confirmedRoom: selectedVerifications.includes("room"),
        verifiedDocs: selectedVerifications.includes("docs"),
        confirmedSpecialReq: selectedVerifications.includes("care"),
      },
      addOnServices: buildAddOnServicesPayload(),
      assignedRooms: assignedRoom?._id || null,
    };

    if (checkInNotes) {
      payload.checkInNotes = checkInNotes;
    }

    try {
      await updateBookingStep(modalData._id, "checkIn", payload);
      setCheckInModalTime(false);
      window.location.reload();
    } catch (error) {
      console.error("Failed to confirm check-in:", error);
    }
  };

  const handleConfirmCheckOut = async () => {
    const payload = {
      isCheckOut: true,
      actualCheckOutTime: new Date(checkOutTime).toISOString(),
      preCheckOutItems: {
        verifiedPet: selectedVerifications.includes("pet"),
        returnedPetBelongings: selectedVerifications.includes("docs"),
        inspectedRoom: selectedVerifications.includes("room"),
        recordedSpecialNotes: selectedVerifications.includes("care"),
      },
      finalCharges: {
        accommodationFee: modalData.checkOut.finalCharges.accommodationFee,
        additionalFee: modalData.checkIn.addOnServices.totalAddOnCost,
        amountPaid: modalData.checkOut.finalCharges.amountPaid,
        amountDue: modalData.checkOut.finalCharges.amountDue,
      },
      confirmedOnSitePayment: paymentConfirmed,
    };

    try {
      await updateBookingStep(modalData._id, "checkOut", payload);
      setCheckOutModalTime(false);
      window.location.reload();
    } catch (error) {
      console.error("Failed to confirm check-out:", error);
    }
  };

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={contentStyle}>
        <Box sx={{ width: isMobile ? "100%" : "80%", mx: "auto", display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
              <Button
                onClick={() => navigate("/hotel/onboarding")}
                sx={{
                  minWidth: "auto",
                  width: isMobile ? "36px" : "44px",
                  height: isMobile ? "36px" : "44px",
                  borderRadius: "50%",
                  backgroundColor: "#31BACD",
                  color: "#fff",
                  padding: 0,
                  alignSelf: isMobile ? "flex-start" : "center",
                  "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                }}
              >
                <ArrowLeft size={isMobile ? 18 : 22} />
              </Button>
              <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 1, alignItems: isMobile ? "flex-start" : "center", }}>
                <Typography sx={{ fontWeight: "bold", fontSize: isMobile ? "20px" : "24px", color: "#000" }}>
                  {`${t('OrderManagement')} > ${t(currentTab)}`}
                </Typography>
              </Box>
            </Box>
          </Box>

          {loading ? (
            <LoadingGif />
          ) : (
            <Box sx={{ width: "100%" }}>
              <Box sx={{ display: "flex", gap: 0, width: "100%", mb: 3 }}>
                {tabs.map((tab) => (
                  <Button
                    key={tab.key}
                    onClick={() => setCurrentTab(tab.key)}
                    sx={{
                      flex: 1,
                      fontSize: "18px",
                      fontWeight: currentTab === tab.key ? "700" : "500",
                      color: currentTab === tab.key ? "#31BACD" : "#666",
                      padding: "12px 0",
                      borderBottom: currentTab === tab.key ? "3px solid #31BACD" : "1px solid #D1D1D1",
                      borderRadius: 0,
                      textTransform: "none",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "#31BACD",
                        backgroundColor: "rgba(49, 186, 205, 0.05)",
                      },
                    }}
                  >
                    {tab.label}
                  </Button>
                ))}
              </Box>

              {/* Dashboard Tab */}
              {currentTab === "DashBoard" && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  {/* Top Stats Cards */}
                  <Box sx={{ display: "flex", gap: "1%", }}>
                    {/* Pending Bookings Card */}
                    <Card
                      sx={{
                        padding: "20px",
                        borderRadius: "10px",
                        border: "1.5px solid #E0E0E0",
                        minHeight: "120px",
                        width: "33%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                        <Box
                          component="img"
                          src="/icons/pendingBookings.svg"
                          alt="Pending Bookings"
                          sx={{ width: "50px", height: "auto" }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Typography sx={{ fontSize: "20px", color: "#000", fontWeight: 700, mb: 0.5 }}>
                            {t("PendingBookings")}
                          </Typography>
                          <Typography sx={{ fontSize: "28px", fontWeight: "700", color: "#31BACD" }}>
                            {pendingBookings}
                          </Typography>
                          <Typography sx={{ fontSize: "14px", color: "#999", mt: 0.5 }}>
                            {t("CompleteWithin48Hours")}
                          </Typography>
                        </Box>
                      </Box>
                    </Card>

                    {/* Today Check-Ins Card */}
                    <Card
                      sx={{
                        width: "33%",
                        flexDirection: "column",
                        gap: 2,
                        padding: "20px",
                        borderRadius: "10px",
                        border: "1.5px solid #E0E0E0",
                        minHeight: "120px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                        <Box
                          component="img"
                          src="/icons/todayCheckIn.svg"
                          alt="Today Check-In"
                          sx={{ width: "50px", height: "auto" }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Typography sx={{ fontSize: "20px", color: "#000", fontWeight: 700, mb: 0.5 }}>
                            {t("TodayCheckIns")}
                          </Typography>
                          <Typography sx={{ fontSize: "28px", fontWeight: "700", color: "#FFB60D" }}>
                            {todayCheckIn}
                          </Typography>
                          <Typography sx={{ fontSize: "14px", color: "#999", mt: 0.5 }}>
                            {t("PendingCheckIns")}
                          </Typography>
                        </Box>
                      </Box>
                    </Card>

                    {/* Today Check-Outs Card */}
                    <Card
                      sx={{
                        width: "33%",
                        padding: "20px",
                        borderRadius: "10px",
                        border: "1.5px solid #E0E0E0",
                        minHeight: "120px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                        <Box
                          component="img"
                          src="/icons/todayCheckOut.svg"
                          alt="Today Check-Out"
                          sx={{ width: "50px", height: "auto" }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Typography sx={{ fontSize: "20px", color: "#000", fontWeight: 700, mb: 0.5 }}>
                            {t("TodayCheckOuts")}
                          </Typography>
                          <Typography sx={{ fontSize: "28px", fontWeight: "700", color: "#E5194A" }}>
                            {todayCheckOut}
                          </Typography>
                          <Typography sx={{ fontSize: "14px", color: "#999", mt: 0.5 }}>
                            {t("PendingCheckOuts")}
                          </Typography>
                        </Box>
                      </Box>
                    </Card>
                  </Box>

                  {/* Middle Row: Pending Bookings Table & Room Status */}
                  <Box sx={{ display: "flex", gap: "2%", flexDirection: isMobile ? "column" : "row" }}>
                    {/* Pending Bookings Table */}
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        padding: "20px",
                        borderRadius: "10px",
                        border: "1.5px solid #E0E0E0",
                        width: isMobile ? "100%" : "49%",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Box sx={{ display: "flex", alignItems: "flex-start", flexDirection: "column", }}>
                          <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000", gap: 1, }}>
                            {t("PendingBookings")}
                          </Typography>
                          <Typography sx={{ fontSize: "14px", color: "#999", }}>
                            {t("PleaseReviewBookings")}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography sx={{ fontSize: "18px", fontWeight: "400", color: "#000", }}>
                            {t("ViewAll")}
                          </Typography>
                          <Button
                            onClick={() => navigate("/hotel/onboarding")}
                            sx={{
                              minWidth: "auto",
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              backgroundColor: "#31BACD",
                              color: "#fff",
                              padding: 0,
                              alignSelf: isMobile ? "flex-start" : "center",
                              "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                            }}
                          >
                            <ArrowRight size={18} />
                          </Button>
                        </Box>
                      </Box>

                      {/* Mock Data Table */}
                      <Box sx={{ overflowX: "auto" }}>
                        <Box sx={{ minWidth: "300px" }}>
                          {pendingBookings !== 0 && (
                            reviewBookings.slice(0, 2).map((booking, idx) => (
                              <Box
                                key={idx}
                                sx={{
                                  display: "flex",
                                  gap: 2,
                                  padding: "12px",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                  <Box
                                    component="img"
                                    src="/icons/reviewPetImage.svg"
                                    alt="Pet"
                                    sx={{ width: "26px", height: "auto" }}
                                  />
                                  <Typography sx={{ fontSize: "16px", color: "#000" }}>
                                    {booking.petName}
                                  </Typography>
                                </Box>
                                <Typography sx={{ fontSize: "14px", color: "#666", whiteSpace: "nowrap" }}>
                                  {`${t("Submitted")}: ${new Date(booking.createdAt).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  })}`}
                                </Typography>
                                <Button
                                  sx={{
                                    fontSize: "14px",
                                    padding: "4px 12px",
                                    backgroundColor: "#fff",
                                    color: "#31BACD",
                                    border: "1px solid #31BACD",
                                    textTransform: "none",
                                    borderRadius: "4px",
                                    "&:hover": { backgroundColor: "#BBDEFB" },
                                  }}
                                  onClick={() => handleOpenModal(booking._id, "review")}
                                >
                                  {t("Review")}
                                </Button>
                              </Box>
                            ))
                          )}
                          {pendingBookings === 0 && (
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, my: 2, }}>
                              <img src="/icons/noRooms.svg" alt="paw" style={{ width: "16px", height: "auto" }} />
                              <Box sx={{ fontSize: "16px", color: "#D9D9D9", fontWeight: 700, }}>
                                {t('NoPendingBookings')}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Card>

                    {/* Room Status */}
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        padding: "20px",
                        borderRadius: "10px",
                        border: "1.5px solid #E0E0E0",
                        width: isMobile ? "100%" : "49%",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                          {t("RoomStatus")}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography sx={{ fontSize: "18px", fontWeight: "400", color: "#000", }}>
                            {t("ViewAll")}
                          </Typography>
                          <Button
                            onClick={() => navigate("/hotel/onboarding")}
                            sx={{
                              minWidth: "auto",
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              backgroundColor: "#31BACD",
                              color: "#fff",
                              padding: 0,
                              alignSelf: isMobile ? "flex-start" : "center",
                              "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                            }}
                          >
                            <ArrowRight size={18} />
                          </Button>
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex", gap: "4%", alignItems: "center", }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "48%", borderRight: "1px solid #AEAEB2", paddingRight: "20px" }}>
                          {/* Room Available */}
                          <Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "space-between" }}>
                            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                              <Box
                                component="img"
                                src="/icons/roomAvailable.svg"
                                alt="Available"
                                sx={{ width: "32px", height: "auto" }}
                              />
                              <Typography sx={{ fontSize: "16px", color: "#000", }}>
                                {t("Available")}
                              </Typography>
                            </Box>
                            <Typography sx={{ fontSize: "16px", color: "#000" }}>
                              {publishedRooms.available || 0}
                            </Typography>
                          </Box>

                          {/* Room Reserved */}
                          <Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "space-between" }}>
                            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                              <Box
                                component="img"
                                src="/icons/roomReserved.svg"
                                alt="Reserved"
                                sx={{ width: "32px", height: "auto" }}
                              />
                              <Typography sx={{ fontSize: "16px", color: "#000", }}>
                                {t("Reserved")}
                              </Typography>
                            </Box>
                            <Typography sx={{ fontSize: "16px", color: "#000" }}>
                              {publishedRooms.reserved || 0}
                            </Typography>
                          </Box>

                          {/* Room Occupied */}
                          <Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "space-between" }}>
                            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                              <Box
                                component="img"
                                src="/icons/roomOccupied.svg"
                                alt="Occupied"
                                sx={{ width: "32px", height: "auto" }}
                              />
                              <Typography sx={{ fontSize: "16px", color: "#000", }}>
                                {t("Occupied")}
                              </Typography>
                            </Box>
                            <Typography sx={{ fontSize: "16px", color: "#000" }}>
                              {publishedRooms.occupied || 0}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Occupancy Rate */}
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            width: "48%",
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", color: "#000", }}>
                            {t("OccupancyRate")}
                          </Typography>
                          <Box sx={{ display: "flex", alignItems: "flex-start", flexDirection: "column", gap: 1 }}>
                            <Box>
                              <Typography sx={{ fontSize: "28px", fontWeight: "700", color: "#000" }}>
                                {CalculateOccupancyRate()}
                              </Typography>
                              <Typography sx={{ fontSize: "14px", color: "#000" }}>
                                {OccupancyStatistics(publishedRooms.occupied || 0, publishedRooms.total || 0)}
                              </Typography>
                            </Box>
                            <LinearProgress
                              variant="determinate"
                              value={CalculateOccupancyRate().replace("%", "")}
                              sx={{
                                height: "6px",
                                width: "100%",
                                borderRadius: "3px",
                                backgroundColor: "#F0F0F0",
                                "& .MuiLinearProgress-bar": {
                                  backgroundColor: "#FF6B35",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Card>
                  </Box>

                  {/* Today's Arrivals Table */}
                  <Box sx={{ display: "flex", gap: 2, flexDirection: isMobile ? "column" : "row" }}>

                    {/* Today's Arrivals Table */}
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 3,
                        width: "100%",
                        padding: "20px",
                        borderRadius: "10px",
                        border: "1.5px solid #E0E0E0",
                      }}
                    >
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", paddingBottom: "10px" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                          {t("TodaysArrivals")}
                        </Typography>
                        <Typography sx={{ fontSize: "14px", color: "#4A5565" }}>
                          {todaysDate + ", " + t(todayNames[day])}
                        </Typography>
                      </Box>

                      <Box sx={{ overflowX: "auto" }}>
                        <Box
                          sx={{
                            minWidth: "100%",
                            display: "grid",
                            alignItems: "center",
                            gridTemplateColumns: "repeat(8, 1fr)",
                            gap: 1,
                            fontSize: "14px",
                          }}
                        >
                          {/* Header */}
                          <Typography sx={{ fontWeight: "700", color: "#000", textAlign: "center", }}>{t("PetName")}</Typography>
                          <Typography sx={{ fontWeight: "700", color: "#000", textAlign: "center" }}>{t("Owner")}</Typography>
                          <Typography sx={{ fontWeight: "700", color: "#000", textAlign: "center" }}>{t("BookingNo")}</Typography>
                          <Typography sx={{ fontWeight: "700", color: "#000", textAlign: "center" }}>{t("Contact")}</Typography>
                          <Typography sx={{ fontWeight: "700", color: "#000", textAlign: "center" }}>{t("ScheduleTime")}</Typography>
                          <Typography sx={{ fontWeight: "700", color: "#000", textAlign: "center" }}>{t("Room")}</Typography>
                          <Typography sx={{ fontWeight: "700", color: "#000", textAlign: "center" }}>{t("Event")}</Typography>
                          <Typography sx={{ fontWeight: "700", color: "#000", textAlign: "center" }}>{t("Action")}</Typography>

                          {/* Data Rows */}
                          {(todayCheckIn !== 0 || todayCheckOut !== 0) && (
                            todayBookings.map((event) => (
                              <>
                                <Typography sx={{ color: "#666", textAlign: "center" }}>{event.petName}</Typography>
                                <Typography sx={{ color: "#666", textAlign: "center" }}>{event.name}</Typography>
                                <Typography sx={{ color: "#666", textAlign: "center" }}>{event.bookingNo}</Typography>
                                <Typography sx={{ color: "#666", textAlign: "center" }}>{event.phoneNumber}</Typography>
                                <Typography sx={{ color: "#666", textAlign: "center" }}>{event.scheduledTime}</Typography>
                                <Typography sx={{ color: "#666", textAlign: "center" }}>{event.roomName}</Typography>
                                <Chip
                                  label={t(event.event === "checkIn" ? "CheckIn" : "CheckOut")}
                                  size="large"
                                  sx={{
                                    backgroundColor: event.event === "checkIn" ? "#FFB60D" : "#E5194A",
                                    color: "#fff",
                                    fontSize: "12px",
                                    height: "25px",
                                    width: "90px",
                                    margin: "0 auto",
                                  }}
                                />
                                <Button
                                  sx={{
                                    fontSize: "14px",
                                    padding: "4px 8px",
                                    margin: "0 auto",
                                    backgroundColor: "#fff",
                                    color: "#31BACD",
                                    border: "1px solid #31BACD",
                                    textTransform: "none",
                                    borderRadius: "4px",
                                    width: "90px",
                                    "&:hover": { backgroundColor: "#BBDEFB" },
                                  }}
                                  onClick={() => handleOpenModal(event._id, event.event)}
                                >
                                  {event.event === "checkIn" ? t("CheckInAction") : t("CheckOutAction")}
                                </Button>
                              </>
                            ))
                          )}
                        </Box>
                        {todayCheckIn === 0 && todayCheckOut === 0 && (
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, my: 5, }}>
                            <img src="/icons/noRooms.svg" alt="paw" style={{ width: "16px", height: "auto" }} />
                            <Box sx={{ fontSize: "16px", color: "#D9D9D9", fontWeight: 700, }}>
                              {t('NoCheckInCheckOutToday')}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Card>
                  </Box>
                </Box>
              )}

              {/* Other Tabs - Placeholder */}
              {currentTab !== "DashBoard" && (
                <Box sx={{ padding: "40px 20px", textAlign: "center" }}>
                  <Typography sx={{ fontSize: "16px", color: "#999" }}>
                    {t(currentTab)} - {t("ComingSoon")}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>

      </div>

      {(checkInModal || checkOutModal || reviewModal) && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "10px",
              width: isMobile ? "95%" : "700px",
              padding: "20px 40px",
              maxHeight: "95vh",
              overflowY: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
                borderBottom: "1px solid #E0E0E0",
                paddingBottom: "8px",
              }}
            >
              <Typography sx={{ fontWeight: "700", fontSize: "20px", color: "#000" }}>
                {checkInModal ? t("CheckIn") : reviewModal ? t("PendingBookings") : t("CheckOut")}
              </Typography>
              <Button
                onClick={() => checkInModal ? setCheckInModal(null) : reviewModal ? closeReviewModal() : setCheckOutModal(null)}
                sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
              >
                <X size={20} />
              </Button>
            </Box>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, width: "100%", }}>
              <Box
                component="img"
                src={checkInModal ? "/icons/reviewCheckIn.svg" : reviewModal ? "/icons/reviewPetImage.svg" : "/icons/reviewCheckOut.svg"}
                alt="Pending Bookings"
                sx={{ width: "50px", height: "auto" }}
              />
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, flexDirection: "column", }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                  <Typography sx={{ fontSize: "16px", color: "#000", fontWeight: 700 }}>
                    {t("PetName")}
                  </Typography>
                  <Typography sx={{ fontSize: "16px", color: "#666" }}>
                    {modalData.petName}
                  </Typography>
                  <Chip
                    label={checkInModal ? t("CheckIn") : reviewModal ? t("Pending") : t("CheckOut")}
                    size="large"
                    sx={{
                      backgroundColor: checkInModal ? "#FFB60D" : reviewModal ? "#31BACD" : "#FF6900",
                      color: "#fff",
                      fontSize: "14px",
                      height: "20px",
                      margin: "0 auto",
                      padding: "4px 8px",
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                  <Typography sx={{ fontSize: "16px", color: "#000", }}>
                    {t("BookingNo")}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: "#4A5565" }}>
                    #{modalData.bookingNo}
                  </Typography>
                </Box>
              </Box>
            </Box>
            {/* Pet & Owner Info Grid */}
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, width: "100%", }}>
              {/* Owner */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                  {t("Owner")}
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                  {modalData.name}
                </Typography>
              </Box>

              {/* Phone */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                  {t("Phone")}
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                  {modalData.phoneNumber}
                </Typography>
              </Box>

              {/* Room Type */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                  {t("RoomType")}
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                  {modalData.roomName}
                </Typography>
              </Box>

              {/* Check-in Time */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                  {t("CheckIn")}
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                  {displayTime(modalData.checkIn.scheduledCheckIn)}
                </Typography>
              </Box>

              {/* Animal Type */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                  {t("Animal")}
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                  {pet.animal === "狗" ? t("AnimalDog") :
                    pet.animal === "貓" ? t("AnimalCat") :
                      pet.animal === "兔" ? t("AnimalRabbit") : t("SmallAnimal")}
                </Typography>
              </Box>

              {/* Check-out Time */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                  {t("CheckOut")}
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                  {displayTime(modalData.checkOut.scheduledCheckOut)}
                </Typography>
              </Box>

              {/* Age */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                  {t("Age")}
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000", }}>
                  {pet.birthday ? calculateAge(pet.birthday) : "N/A"}
                </Typography>
              </Box>

              {/* Sex & Sterilized */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                  {t("Sex")}
                </Typography>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                    {pet.sex === "male" ? t("Male") : t("Female")}
                  </Typography>
                  <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                    {pet.sterilized ? t("Sterilized") : t("NotSterilized")}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Special Requirements */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
              <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000", }}>
                {t("SpecialRequirement")}
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#FFFDE7",
                  border: "1px solid #FBC02D",
                  borderRadius: "8px",
                  padding: "12px",
                  display: "flex",
                  gap: 1,
                }}
              >
                <Typography sx={{ fontSize: "14px", color: "#F57F17" }}>
                  {modalData.checkIn.specialRequirements || "N/A"}
                </Typography>
              </Box>
            </Box>

            {!reviewModal && (
              <Box sx={{ display: "flex", flexDirection: "column", width: "100%", }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                  <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                    {checkInModal ? t("PreCheckInVerification") : t("PreCheckOutVerification")}
                    <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", border: "1px solid #6A7282", borderRadius: "10px", cursor: "pointer" }}>
                    <Checkbox
                      size="small"
                      checked={selectedVerifications.length === 4}
                      onChange={(e) => {
                        if (selectedVerifications.length === 4) {
                          setSelectedVerifications([]);
                        } else {
                          setSelectedVerifications(["pet", "room", "docs", "care"]);
                        }
                      }}
                      sx={{
                        color: "#999",
                        "&.Mui-checked": {
                          color: "#31BACD",
                        },
                      }}
                    />
                    <Typography sx={{ cursor: "pointer", fontSize: "16px", paddingRight: "8px", color: "#6A7282" }}>
                      {t("SelectAll")}
                    </Typography>
                  </Box>
                </Box>

                {/* Verification Items */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedVerifications.includes("pet")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedVerifications([...selectedVerifications, "pet"]);
                          } else {
                            setSelectedVerifications(selectedVerifications.filter(v => v !== "pet"));
                          }
                        }}
                        sx={{
                          color: "#999",
                          "&.Mui-checked": {
                            color: "#31BACD",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "16px", color: "#333" }}>
                        {checkInModal ? t("VerifyPetIdentity") : t("PetIdentityVerified")}
                      </Typography>
                    }
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedVerifications.includes("room")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedVerifications([...selectedVerifications, "room"]);
                          } else {
                            setSelectedVerifications(selectedVerifications.filter(v => v !== "room"));
                          }
                        }}
                        sx={{
                          color: "#999",
                          "&.Mui-checked": {
                            color: "#31BACD",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "16px", color: "#333" }}>
                        {checkInModal ? t("ConfirmRoomType") : t("RoomInspectionCompleted")}
                      </Typography>
                    }
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedVerifications.includes("docs")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedVerifications([...selectedVerifications, "docs"]);
                          } else {
                            setSelectedVerifications(selectedVerifications.filter(v => v !== "docs"));
                          }
                        }}
                        sx={{
                          color: "#999",
                          "&.Mui-checked": {
                            color: "#31BACD",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "16px", color: "#333" }}>
                        {checkInModal ? t("VerifyRequiredDocs") : t("PetBelongingsReturned")}
                      </Typography>
                    }
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedVerifications.includes("care")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedVerifications([...selectedVerifications, "care"]);
                          } else {
                            setSelectedVerifications(selectedVerifications.filter(v => v !== "care"));
                          }
                        }}
                        sx={{
                          color: "#999",
                          "&.Mui-checked": {
                            color: "#31BACD",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "16px", color: "#333" }}>
                        {checkInModal ? t("ConfirmSpecialCare") : t("SpecialNotesRecorded")}
                      </Typography>
                    }
                  />
                </Box>
              </Box>
            )}

            {reviewModal && (
              <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 1, mt: 2, }}>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                  <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                    {t("RequiredDocuments")}
                    <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #E0E0E0", borderRadius: "8px", }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                    <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                      {t("Vaccination / Veterinary Records")}
                    </Typography>
                    {modalData.documentsUploaded ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 3, color: "#31BACD", cursor: "pointer", "&:hover": { color: "#8cbec4" }, }}
                        onClick={() => openReviewDocument(modalData._id)}
                      >
                        <Typography sx={{ fontSize: "16px", }}>
                          {t("View")}
                        </Typography>
                        <Box
                          component="img"
                          src="/icons/tick.svg"
                          alt="alert"
                          sx={{ width: "20px", height: "auto" }}
                        />
                      </Box>
                    ) : (
                      <Box
                        component="img"
                        src="/icons/redCross.svg"
                        alt="alert"
                        sx={{ width: "20px", height: "auto" }}
                      />
                    )}
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                    <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                      {t("Terms&Conditions")}
                    </Typography>
                    {modalData.termsAgreed ? (
                      <Box
                        component="img"
                        src="/icons/tick.svg"
                        alt="alert"
                        sx={{ width: "20px", height: "auto" }}
                      />
                    ) : (
                      <Box
                        component="img"
                        src="/icons/redCross.svg"
                        alt="alert"
                        sx={{ width: "20px", height: "auto" }}
                      />)
                    }
                  </Box>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 2, }}>
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                    <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                      {t("ReviewResults")}
                      <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                    </Typography>

                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                    {reviewResultsLabel.map((data, idx) => (
                      <FormControlLabel
                        key={idx}
                        control={
                          <Radio
                            checked={reviewResults === data.label}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setReviewResults(data.label);
                              }
                            }}
                            sx={{
                              color: "#999",
                              padding: "0",
                              mx: 1,
                              "&.Mui-checked": {
                                color: idx === 0 ? "#31BACD" : "#E5194A",
                              },
                            }}
                          />
                        }
                        label={
                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                              {t(data.label)}
                            </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#333" }}>
                              {t(data.description)}
                            </Typography>
                          </Box>
                        }
                        sx={{
                          border: "1px solid #D1D1D1",
                          borderRadius: "8px",
                          padding: "8px",
                          margin: 0,
                          width: "100%",
                          display: "flex",
                          alignItems: "flex-start",
                          "&:hover": {
                            borderColor: idx === 0 ? "#31BACD" : "#E5194A",
                            backgroundColor: idx === 0 ? "rgba(49, 186, 205, 0.05)" : "rgba(229, 25, 74, 0.05)",
                          },
                        }}
                      />
                    ))}
                  </Box>

                </Box>

                {reviewResults === "UnableToConfirmBooking" && (
                  <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 2, }}>
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                      <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                        {t("PleaseSelectReason")}
                        <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                      {UnConfirmReviewReasonLabel.map((data, idx) => (
                        <>
                          {data.label === "RequiredInfoDocs1" ? (
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#4A5565" }}>
                              {t("RequiredInfoDocs")}
                            </Typography>
                          ) : data.label === "Care&Accomodation1" ? (
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#4A5565", mt: 2, }}>
                              {t("Care&Accomodation")}
                            </Typography>
                          ) : data.label === "HotelOperations1" ? (
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#4A5565", mt: 2, }}>
                              {t("HotelOperations")}
                            </Typography>
                          ) : data.label === "Other1" ? (
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#4A5565", mt: 2, }}>
                              {t("Other")}
                            </Typography>
                          ) : null}
                          <FormControlLabel
                            key={idx}
                            control={
                              <Radio
                                checked={unConfirmReason === data.label}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setUnConfirmReason(data.label);
                                  }
                                }}
                                sx={{
                                  color: "#999",
                                  "&.Mui-checked": {
                                    color: "#31BACD",
                                  },
                                }}
                              />
                            }
                            label={
                              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", }}>
                                <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                  {t(data.label)}
                                </Typography>
                              </Box>
                            }
                            sx={{
                              border: "1px solid #D1D1D1",
                              borderRadius: "8px",
                              padding: "8px",
                              margin: 0,
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              "&:hover": {
                                borderColor: "#31BACD",
                                backgroundColor: "rgba(49, 186, 205, 0.05)",
                              },
                            }}
                          />
                          {data.label === "RequiredInfoDocs1" && unConfirmReason === "RequiredInfoDocs1" && (
                            <Box sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              backgroundColor: "#FEF3CD",
                              border: "1px solid #F5A6234D",
                              borderRadius: "10px",
                              padding: "8px 16px",
                              width: "100%",
                            }}>
                              <Box component="img" src="/icons/ReasonsWhatsApp.svg" alt="" sx={{ width: 25, height: "auto", }} />
                              <Typography sx={{ fontSize: "14px", color: "#B07A0A" }}>
                                {`${t("RequiredInfoWarning1")}${modalData.phoneNumber}${t("RequiredInfoWarning2")}`}
                              </Typography>
                            </Box>
                          )}
                          {data.label === "Care&Accomodation3" && (unConfirmReason === "Care&Accomodation1" || unConfirmReason === "Care&Accomodation2" || unConfirmReason === "Care&Accomodation3") && (
                            <Box sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              backgroundColor: "#FEF3CD",
                              border: "1px solid #F5A6234D",
                              borderRadius: "10px",
                              padding: "8px 16px",
                              width: "100%",
                            }}>
                              <Box component="img" src="/icons/ReasonsWhatsApp.svg" alt="" sx={{ width: 25, height: "auto", }} />
                              <Typography sx={{ fontSize: "14px", color: "#B07A0A" }}>
                                {`${t("Care&AccomodationWarning1")}${modalData.phoneNumber}${t("Care&AccomodationWarning2")}`}
                              </Typography>
                            </Box>
                          )}
                          {data.label === "HotelOperations1" && unConfirmReason === "HotelOperations1" && (
                            <Box sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              backgroundColor: "#FEF3CD",
                              border: "1px solid #F5A6234D",
                              borderRadius: "10px",
                              padding: "8px 16px",
                              width: "100%",
                            }}>
                              <Box component="img" src="/icons/ReasonsWhatsApp.svg" alt="" sx={{ width: 25, height: "auto", }} />
                              <Typography sx={{ fontSize: "14px", color: "#B07A0A" }}>
                                {`${t("Care&AccomodationWarning1")}${modalData.phoneNumber}${t("Care&AccomodationWarning2")}`}
                              </Typography>
                            </Box>
                          )}
                          {data.label === "Other1" && unConfirmReason === "Other1" && (
                            <Box sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              backgroundColor: "#FEF3CD",
                              border: "1px solid #F5A6234D",
                              borderRadius: "10px",
                              padding: "8px 16px",
                              width: "100%",
                            }}>
                              <Box component="img" src="/icons/ReasonsWhatsApp.svg" alt="" sx={{ width: 25, height: "auto", }} />
                              <Typography sx={{ fontSize: "14px", color: "#B07A0A" }}>
                                {`${t("Care&AccomodationWarning1")}${modalData.phoneNumber}${t("Care&AccomodationWarning2")}`}
                              </Typography>
                            </Box>
                          )}
                        </>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {checkInModal && (
              <Box sx={{ display: "flex", flexDirection: "column", width: "100%", }}>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                  <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                    {t("AddonServices")}
                  </Typography>
                  <Button
                    onClick={() => dropdownAddOpen ? setDropdownAddOpen(false) : setDropdownAddOpen(true)}
                    sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
                  >
                    {dropdownAddOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </Button>
                </Box>
                {dropdownAddOpen && (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                    {SERVICE_OPTIONS.map((service) => {
                      const isSelected = additionalServices.selectedServices[service.key];
                      return isSelected ? (
                        <Box key={service.key} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px", border: "1px solid #E0E0E0", borderRadius: "8px", }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                            <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                              {t(service.labelKey)}
                            </Typography>
                            {additionalServices.selectedServices[service.key] && (
                              <Typography sx={{ fontWeight: "600", fontSize: isMobile ? "14px" : "16px", color: "#000" }}>
                                {`HK$${additionalServices.servicePrices[service.key]} ${service.unitKey === "UnitPerMinute" ? `/ ${additionalServices.servicePrices.playtime} ` : ''}${t(service.unitKey)}`}
                              </Typography>
                            )}
                          </Box>
                          <TextField
                            fullWidth
                            type="number"
                            inputProps={{ min: 0 }}
                            value={formData.addOnQuantities[service.key] ?? 0}
                            onChange={(e) => handleAddOnQuantityChange(service.key, Number(e.target.value))}
                            sx={{
                              width: "100px",
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "#FFFFFF",
                                borderRadius: "10px",
                              },
                              "& .MuiOutlinedInput-input": {
                                padding: "10px",
                              },
                            }}
                          />
                        </Box>
                      ) : null;
                    })}
                  </Box>
                )}
              </Box>
            )}
            {checkOutModal && (
              <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 1 }}>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                  <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                    {t("FinalCharges")}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #E0E0E0", borderRadius: "8px", }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                    <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                      {t("AccommodationFee")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#31BACD" }}>
                      {modalData.checkOut.finalCharges.accommodationFee}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                    <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                      {t("AdditionalServiceFee")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#31BACD" }}>
                      {modalData.checkIn.addOnServices.totalAddOnCost}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                    <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                      {t("AmountPaid")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#31BACD", }}>
                      {modalData.checkOut.finalCharges.amountPaid}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#F5F5F5", padding: "16px", }}>
                    <Typography sx={{ fontSize: "16px", color: "#000", fontWeight: "700" }}>
                      {t("TotalCharges")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#31BACD", fontWeight: "700" }}>
                      {modalData.checkOut.finalCharges.amountDue}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            {(checkInModal || reviewResults === "ConfirmBooking") && (
              <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 2 }}>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                  <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                    {t("AssignRoom")}
                    <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                  </Typography>
                  {checkInModal && (
                    <Button
                      onClick={() => dropdownRoomOpen ? setDropdownRoomOpen(false) : setDropdownRoomOpen(true)}
                      sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
                    >
                      {dropdownRoomOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                    </Button>)}
                </Box>
                {(dropdownRoomOpen || reviewResults === "ConfirmBooking") && (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
                      {assignRooms.map((arrival, idx) => (
                        <FormControlLabel
                          key={idx}
                          control={
                            <Radio
                              checked={selectedRoomType === arrival.roomName}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedRoomType(arrival.roomName);
                                }
                              }}
                              sx={{
                                color: "#999",
                                "&.Mui-checked": {
                                  color: "#31BACD",
                                },
                              }}
                            />
                          }
                          label={
                            <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
                              {arrival.roomName}
                            </Typography>
                          }
                          sx={{
                            border: "1px solid #D1D1D1",
                            borderRadius: "8px",
                            padding: "4px 8px",
                            margin: 0,
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            "&:hover": {
                              borderColor: "#31BACD",
                              backgroundColor: "rgba(49, 186, 205, 0.05)",
                            },
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {checkInModal && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                  <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                    {t("CheckInNotes")}
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  placeholder={t("CheckInNotes") + t("OptionalLabel")}
                  value={checkInNotes}
                  onChange={(e) => setCheckInNotes(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#FFFFFF",
                      borderRadius: "10px",
                    },
                  }}
                />
              </Box>
            )}
            {checkOutModal && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                  <Box
                    component="img"
                    src="/icons/alertPayment.svg"
                    alt="alert"
                    sx={{ width: "16px", height: "auto" }}
                  />
                  <Typography sx={{ fontSize: "14px", color: "#E5194A" }}>
                    {t("PleaseConfirmBeforeCheckOut")}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", background: "#e5194912", border: "1px solid #E5194A", borderRadius: "10px", cursor: "pointer", padding: "10px 0" }}>
                  <Checkbox
                    size="medium"
                    checked={paymentConfirmed}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPaymentConfirmed(true);
                      } else {
                        setPaymentConfirmed(false);
                      }
                    }}
                    sx={{
                      color: "#e5194992",
                      "&.Mui-checked": {
                        color: "#E5194A",
                      },
                    }}
                  />
                  <Box sx={{ display: "flex", flexDirection: "column", }}>
                    <Typography sx={{ cursor: "pointer", fontSize: "16px", color: "#E5194A", fontWeight: "700" }}>
                      {t("ConfirmOnSitePayment")}
                    </Typography>
                    <Typography sx={{ cursor: "pointer", fontSize: "12px", color: "#6A7282" }}>
                      {t("PleaseConfirmOnSitePayment")}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            {/* Action Buttons */}
            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", alignSelf: "flex-end", }}>
              <Button
                onClick={() => checkInModal ? setCheckInModal(false) : reviewModal ? closeReviewModal() : setCheckOutModal(false)}
                sx={{
                  padding: "10px 24px",
                  backgroundColor: "#F5F5F5",
                  color: "#666",
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  "&:hover": { backgroundColor: "#EBEBEB" },
                }}
              >
                {t("Cancel")}
              </Button>
              <Button
                sx={{
                  padding: "10px 24px",
                  backgroundColor: "#31BACD",
                  color: "#fff",
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  "&:hover": { backgroundColor: "#2BA5B8" },
                  "&:disabled": { backgroundColor: "#F5F5F5", },
                }}
                disabled={reviewModal ? !confirmButtonDisabled2 : confirmButtonDisabled1}
                onClick={checkInModal ? openCheckInTimeModal : reviewModal ? handleReviewBooking : openCheckOutTimeModal}
              >
                {t("Confirm")}
              </Button>
            </Box>
          </Box>
        </Box>
      )}

      {(checkInModalTime || checkOutModalTime) && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 2 : 4,
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "24px",
              width: isMobile ? "80%" : "auto",
              maxWidth: "700px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <Box sx={{ width: isMobile ? "100%" : "320px", flexShrink: 0, }}>
              <Box
                component="img"
                src="/icons/ppclogo.png"
                alt="Pet Pet Club"
                sx={{ height: isMobile ? "20px" : "24px", mb: 2 }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1, }}>
                <img src={checkInModalTime ? "/icons/hotelUpdated.svg" : "/icons/hotelUpdated2.svg"} alt="hotel updated" style={{ width: "56px", height: "auto" }} />
                <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                  {checkInModalTime ? t("ConfirmCheckInTitle") : t("ConfirmCheckOutTitle")}
                </Typography>
                <Typography sx={{ fontSize: "16px", color: "#000" }}>
                  {t("PleaseReview")}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, padding: "10px", backgroundColor: "#31BACD1A", borderRadius: "8px", width: "100%", border: "1px solid #31BACD", }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("PetName")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {modalData.petName}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("Owner")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {modalData.name}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("BookingNo")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {modalData.bookingNo}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("RoomType")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {modalData.roomName}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("StayPeriod")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {displayTime(modalData.checkIn.scheduledCheckIn)} – {displayTime(modalData.checkOut.scheduledCheckOut)}
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", display: "flex", alignSelf: "flex-start", }}>
                  {checkInModalTime ? t("ActualCheckInTime") : t("ActualCheckOutTime")}
                </Typography>

                <TextField
                  type="datetime-local"
                  value={checkInModalTime ? checkInTime : checkOutTime}
                  onChange={(e) => checkInModalTime ? setCheckInTime(e.target.value) : setCheckOutTime(e.target.value)}
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "12px",
                      fontSize: "16px",
                    },
                  }}
                />

                <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                  <Button
                    onClick={() => checkInModalTime ? setCheckInModalTime(false) : setCheckOutModalTime(false)}
                    sx={{
                      padding: "8px 12px",
                      backgroundColor: "#F5F5F5",
                      color: "#666",
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "10px",
                      "&:hover": { backgroundColor: "#EBEBEB" },
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                  <Button
                    sx={{
                      padding: "8px 12px",
                      backgroundColor: "#31BACD",
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "10px",
                      "&:hover": { backgroundColor: "#2BA5B8" },
                    }}
                    onClick={() => checkInModalTime ? handleConfirmCheckIn() : handleConfirmCheckOut()}
                  >
                    {t("Confirm")}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {(bookingConfirmed || bookingUnConfirmed) && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 2 : 4,
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "24px",
              width: isMobile ? "80%" : "auto",
              maxWidth: "700px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <Box sx={{ width: isMobile ? "100%" : "350px", flexShrink: 0, }}>
              <Box
                component="img"
                src="/icons/ppclogo.png"
                alt="Pet Pet Club"
                sx={{ height: isMobile ? "20px" : "24px", mb: 2 }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, }}>
                <img src={bookingConfirmed ? "/icons/hotelUpdated.svg" : "/icons/bookingUnConfirmed.svg"} alt="lock" style={{ width: "56px", height: "auto" }} />
                <Typography sx={{ fontSize: "16px", color: "#000", fontWeight: "700" }}>
                  {bookingConfirmed ? t('BookingConfirmed') : t('CustomerNotified')}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#000", alignSelf: "center", display: "flex", textAlign: "center", }}>
                  {bookingConfirmed ? t('BookingConfirmed1') : t('CustomerNotified1')}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#000", alignSelf: "center", display: "flex", textAlign: "center", }}>
                  {bookingConfirmed ? t('BookingConfirmed2') : null}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, width: "40%", }}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => window.location.reload()}
                    sx={{
                      backgroundColor: "#31BACD",
                      color: "#fff",
                      borderRadius: "10px",
                      textTransform: "none",
                      fontSize: isMobile ? "13px" : "14px",
                      padding: "8px 16px",
                      "&:hover": { backgroundColor: "#60bac6", },
                    }}
                  >
                    {t('Confirm')}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {previewFile && (
        <Box
          onClick={() => setPreviewFile(null)}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: isMobile ? "20px" : "40px",
          }}
        >
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              width: "100%",
              maxWidth: "800px",
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <Typography sx={{ fontWeight: "600", fontSize: "14px", color: "#000" }}>
                {t("Vaccination / Veterinary Records")}
              </Typography>
              <Button
                onClick={() => setPreviewFile(null)}
                sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
              >
                <X size={20} />
              </Button>
            </Box>
            <Box sx={{ flex: 1, overflow: "auto", backgroundColor: "#F5F5F5" }}>
              {isPdf(previewFile.file) ? (
                <Box
                  component="iframe"
                  src={previewFile.url}
                  onError={() => console.error("Failed to load PDF:", previewFile.url)}
                  sx={{ width: "100%", height: isMobile ? "70vh" : "80vh", border: "none" }}
                />
              ) : (
                <Box
                  component="img"
                  src={previewFile.url}
                  alt="document"
                  onError={() => console.error("Failed to load image:", previewFile.url)}
                  sx={{ width: "100%", height: "auto", display: "block" }}
                />
              )}
            </Box>
          </Box>
        </Box>
      )}
      <Footer />
    </div>
  );
};

export default HotelOrderManagement;
